export const ADDRESS_NOTIFICATIONS = Object.freeze({
  AFTERPAY_UNAVAILABLE: 'address.klarna_unavailable',
  APO_NOTIFICATION: 'address.apo.notification',
  OFFER_REPLACED_SKUS_RESTRICTED: 'offer.replaced.skus.restricted',
});

export const CART_NOTIFICATIONS = Object.freeze({
  DONATION_REMOVED: 'donation_has_been_removed',
  OFFER_REMOVED: 'offer_criteria_not_met',
  SIGNATURE_REQUIRED: 'signature_required',
});

export const BOPIS_NOTIFICATION = Object.freeze({
  GIFT_WRAP_REMOVED: 'bopis.non_sample.cart_item_deleted',
  STORE_CHANGED: 'bopis.store_changed',
});

export const PAYMENT_NOTIFICATIONS = Object.freeze({
  AFTER_PAY_NOT_AVAILABLE: 'payment_provider.after_pay_not_available',
});

export const SHIPPING_PAYMENT_NOTIFICATIONS = Object.freeze({
  SHIPPING_SET_TO_DEFAULT: 'shipmethod_set_to_default',
});

export const DisregardedNotifications: string[] = [
  PAYMENT_NOTIFICATIONS.AFTER_PAY_NOT_AVAILABLE,
];

export const SHIPPING_NOTIFICATIONS = Object.freeze({
  PRODUCT_HAZMAT_RESTRICTION: 'shipping_restriction.hazmat',
});

export enum NOTIFICATION_TYPE {
  SUCCESS = 'SUCCESS',
  DANGER = 'DANGER',
  WARNING = 'WARNING',
  INFO = 'INFO',
  NEUTRAL = 'NEUTRAL',
}

export enum NOTIFICATION_GROUP {
  APP = 'app',
  BILLING = 'billing',
  BOPIS = 'bopis',
  COMPANY_BILLLING = 'companyBilling',
  SHIPPING = 'shipping',
  PAYMENT = 'payment',
  SHIPPING_PAYMENT = 'shippingToPayment',
  GIFT_WRAP = 'giftWrap',
  GIFT_WRAP_MESSAGE = 'giftWrapMessage',
  DONATIONS = 'donations',
  SHIPPING_PAYMENT_WARNING = 'shipping_payment_warning',
  BILLING_PAYMENT_WARNING = 'billing_payment_warning',
  SALON = 'salon',
}
